
/* Check Value */
export const check = (value, defaultValue = "") => {

    if (value === null || defaultValue === undefined) {
        return defaultValue
    }

    return value
}

/* Second to Time */
export const formatTime = (seconds = 0) => {

    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60

    const pad = n => String(n).padStart(2, "0")

    return `${pad(h)}:${pad(m)}:${pad(s)}`
}